import { z } from "zod";
import { PublicUrlSchema } from "../entities/storeProfile.js";

export const InvitationPreviewResponseSchema = z.object({
  storeName: z.string().min(1).max(128),
  email: z.string().email(),
  role: z.string().min(1).max(32).nullable(),
  status: z.literal("pending"),
  expiresAt: z.string(),
  inviterName: z.string().min(1).nullable(),
  logoUrl: PublicUrlSchema.nullable(),
});
export type InvitationPreviewResponse = z.infer<typeof InvitationPreviewResponseSchema>;
